import { render, staticRenderFns } from "./ProductSale.vue?vue&type=template&id=07957b2e&"
import script from "./ProductSale.vue?vue&type=script&lang=js&"
export * from "./ProductSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports